export default (
  state = {
    selectedAccount: null,
    accountDocs: [],
    accountGlobalDocs: [],
    accounts: [],
    documentTypes: [],
  },
  action,
) => {
  switch (action.type) {
    case "ASSETS_INIT_DATA":
      return {
        ...state,
        accounts: action.payload[0].Accounts,
        documentTypes: action.payload[1],
      };
    case "ASSETS_BY_ACCOUNT":
      return {
        ...state,
        selectedAccount: action.payload.Assets.crm_account,
        accountDocs: action.payload.Assets.opp_docs,
        accountGlobalDocs: action.payload.Assets.global_docs,
      };
    case "UPDATE_ACCOUNT_DOCS":
      return {
        ...state,
        accountDocs: action.payload,
      };
    case "UPDATE_ACCOUNTS_IN_ASSETS":
      return {
        ...state,
        accounts: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AssetsReducer.js